var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoRem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.5H17.78L15.92 12.87L16 8",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.62 16.4502C14.62 18.1902 12.91 19.1502 10.81 19.1502C8.71 19.1502 7 18.1902 7 16.4502",
    fill: "#FF0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8193 3.99995L16.7293 2.86995C16.6863 2.8284 16.629 2.80518 16.5693 2.80518C16.5095 2.80518 16.4522 2.8284 16.4093 2.86995L3.77925 14.9999C3.75773 15.0196 3.74053 15.0436 3.72877 15.0703C3.71701 15.0969 3.71094 15.1258 3.71094 15.1549C3.71094 15.1841 3.71701 15.213 3.72877 15.2396C3.74053 15.2663 3.75773 15.2903 3.77925 15.3099L4.86925 16.4299C4.88982 16.4517 4.91462 16.4691 4.94213 16.481C4.96964 16.4928 4.99929 16.499 5.02925 16.499C5.05921 16.499 5.08886 16.4928 5.11637 16.481C5.14389 16.4691 5.16869 16.4517 5.18925 16.4299L17.8193 4.29995C17.8572 4.25922 17.8783 4.20562 17.8783 4.14995C17.8783 4.09428 17.8572 4.04067 17.8193 3.99995Z",
    fill: "#FF0000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6209 3.00021C13.5209 1.70021 11.7209 1.48021 9.96086 1.48021C9.12288 1.47225 8.29635 1.67504 7.55721 2.06995C6.81808 2.46485 6.19005 3.0392 5.73086 3.74021C4.85364 5.11814 4.38551 6.71674 4.38086 8.35021V12.4002",
    fill: "#FF0000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRem);
export default __webpack_public_path__ + "static/media/no-rem.88bc59434c206a8439dc8c088c13b66d.svg";
export { ForwardRef as ReactComponent };